import React, { useCallback } from 'react';
import { Button, Message } from '@alifd/next';
import axios from 'axios';

export default function CreateMonthlyBillButton({ setTrigger }) {
  // 產生帳單
  const handleCreateBill = useCallback(async () => {
    Message.loading({
      content: '產生帳單中...',
      duration: 0,
    });
    try {
      await axios.post(
        '/ezcon/api/createFinanceAndBill',
        {},
        {
          headers: {
            authorization: localStorage.getItem('feathers-jwt'),
          },
        }
      );
      Message.success('帳單產生成功');
      setTrigger({});
    } catch (err) {
      console.error(err);
      Message.error('產生帳單失敗');
    }
  }, [setTrigger]);

  return (
    <>
      <Button onClick={handleCreateBill}>產生帳單</Button>
    </>
  );
}
